import '../scss/app.scss';
import '../../../common/sso/js/index';
import '../../common/images/index';
